export function handleSofortIbanFieldVisibility(gateway) {
  if (gateway === 'Sofort') {
    $('#sofort_bank_account_number').removeClass('hidden');
  } else {
    $('#sofort_bank_account_number').addClass('hidden');
  }
}
